<div class="wallet-shell" [class.nav-open]="mobileNavOpen">
  <header class="wallet-header">
    <div class="header-left">
      <button class="icon-btn d-lg-none" type="button" (click)="toggleMobileNav()" aria-label="Ouvrir la navigation">
        <i class="bi bi-list"></i>
      </button>

      <a class="brand" routerLink="/spay" (click)="closeMobileNav()">
        <img src="assets/icons/spay.png" alt="Logo Spay" />
        <span class="brand-copy">
          <strong>SPAY</strong>
          <small>Porte-monnaie électronique</small>
        </span>
      </a>
    </div>

    <div class="header-meta" *ngIf="loggedIn">
      <span class="status-pill"><i class="bi bi-shield-check"></i> Connecté</span>
      <span class="status-pill status-soft">{{ getCurrentAreaLabel() }}</span>
    </div>

    <div class="header-actions">
      <button *ngIf="shouldInstall()" type="button" class="btn btn-sm btn-outline-light header-btn"
        (click)="installPWA()">
        Installer
      </button>

      <button *ngIf="updateAvailable" type="button" class="btn btn-sm btn-warning header-btn" (click)="reload()">
        Mise à jour
      </button>

      <a *ngIf="!loggedIn" routerLink="/connection" class="btn btn-sm btn-outline-light header-btn">
        Connexion
      </a>

      <a *ngIf="!loggedIn" routerLink="/signup" class="btn btn-sm btn-light header-btn">
        Inscription
      </a>

      <button *ngIf="loggedIn" type="button" class="btn btn-sm btn-light header-btn" (click)="logout()">
        Déconnexion
      </button>
    </div>
  </header>

  <div class="wallet-body">
    <aside class="wallet-nav" [class.open]="mobileNavOpen">
      <div class="wallet-nav-content">
        <p class="nav-heading">Navigation</p>

        <a class="nav-link-item" routerLink="/spay" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobileNav()">
          <i class="bi bi-house-door"></i>
          <span>Accueil</span>
        </a>

        <a class="nav-link-item" *ngIf="showDevDocsLink" routerLink="/dev/docs/deploiement" routerLinkActive="active"
          (click)="closeMobileNav()">
          <i class="bi bi-journal-code"></i>
          <span>Documentation Dev</span>
        </a>

        <ng-container *ngIf="!loggedIn">
          <a class="nav-link-item" routerLink="/connection" routerLinkActive="active" (click)="closeMobileNav()">
            <i class="bi bi-box-arrow-in-right"></i>
            <span>Connexion</span>
          </a>
          <a class="nav-link-item" routerLink="/signup" routerLinkActive="active" (click)="closeMobileNav()">
            <i class="bi bi-person-plus"></i>
            <span>Inscription</span>
          </a>
          <a class="nav-link-item" routerLink="/utilisateur/reset/password" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-key"></i>
            <span>Mot de passe oublié</span>
          </a>
        </ng-container>

        <ng-container *ngIf="isClientArea()">
          <p class="nav-heading mt-3">Porte-monnaie</p>

          <a class="nav-link-item" routerLink="/utilisateur/espace-client" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-speedometer2"></i>
            <span>Tableau de bord</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/codes" routerLinkActive="active" (click)="closeMobileNav()">
            <i class="bi bi-wallet2"></i>
            <span>Mes comptes</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/transaction" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-arrow-left-right"></i>
            <span>Transfert</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateurs/transferts" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-clock-history"></i>
            <span>Activité</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateurs/identification" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-person-check"></i>
            <span>Identification</span>
          </a>

          <a class="nav-link-item" routerLink="/informations/personel" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-person-circle"></i>
            <span>Profil</span>
          </a>
        </ng-container>

        <ng-container *ngIf="isGestionnaire">
          <p class="nav-heading mt-3">Gestionnaire</p>

          <a class="nav-link-item" routerLink="/utilisateur/gestionnaire/espace" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-briefcase"></i>
            <span>Espace gestionnaire</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/ajouter/membre" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-person-plus"></i>
            <span>Creer membre</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/compte/personel" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-people"></i>
            <span>Comptes personnels</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/compte/professionel" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-building"></i>
            <span>Comptes pro</span>
          </a>
        </ng-container>

        <ng-container *ngIf="isCaissier">
          <p class="nav-heading mt-3">Caissier</p>

          <a class="nav-link-item" routerLink="/utilisateur/bspace" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-cash-stack"></i>
            <span>Ma caisse</span>
          </a>
        </ng-container>

        <ng-container *ngIf="isPartner || isPlatformPartner">
          <p class="nav-heading mt-3">Partenaire</p>

          <a class="nav-link-item" [routerLink]="getPartnerDashboardRoute()" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-grid"></i>
            <span>Dashboard</span>
          </a>

          <ng-container *ngIf="isPartner && !isPlatformPartner">
            <a class="nav-link-item" routerLink="/utilisateur/partenaire/depot" routerLinkActive="active"
              (click)="closeMobileNav()">
              <i class="bi bi-box-arrow-in-down"></i>
              <span>Dépôt</span>
            </a>

            <a class="nav-link-item" routerLink="/utilisateur/partenaire/retrait" routerLinkActive="active"
              (click)="closeMobileNav()">
              <i class="bi bi-box-arrow-up"></i>
              <span>Retrait</span>
            </a>

            <a class="nav-link-item" routerLink="/utilisateur/partenaire/ajouter/employer" routerLinkActive="active"
              (click)="closeMobileNav()">
              <i class="bi bi-people"></i>
              <span>Employés</span>
            </a>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isAdmin">
          <p class="nav-heading mt-3">Administration</p>

          <a class="nav-link-item" routerLink="/utilisateur/admin/dashboard" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-columns-gap"></i>
            <span>Dashboard</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/ajouter/membre" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-person-plus"></i>
            <span>Creer membre</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/ledger/accounts" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-journal-text"></i>
            <span>Ledger comptes</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/ledger/transactions" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-arrow-left-right"></i>
            <span>Ledger transactions</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/bank/deposits" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-bank"></i>
            <span>Dépôts banque</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/billing/invoices" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-receipt"></i>
            <span>Factures</span>
          </a>

          <a class="nav-link-item" routerLink="/utilisateur/admin/tax-rules" routerLinkActive="active"
            (click)="closeMobileNav()">
            <i class="bi bi-percent"></i>
            <span>Règles taxe</span>
          </a>
        </ng-container>
      </div>
    </aside>

    <button *ngIf="mobileNavOpen" type="button" class="wallet-backdrop" (click)="closeMobileNav()"
      aria-label="Fermer la navigation"></button>

    <main class="wallet-main">
      <div class="wallet-content">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <nav class="wallet-mobile-tabs" *ngIf="isClientArea()">
    <a routerLink="/utilisateur/espace-client" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <i class="bi bi-house-door"></i>
      <span>Accueil</span>
    </a>
    <a routerLink="/utilisateur/codes" routerLinkActive="active">
      <i class="bi bi-wallet2"></i>
      <span>Wallet</span>
    </a>
    <a routerLink="/utilisateur/transaction" routerLinkActive="active">
      <i class="bi bi-arrow-left-right"></i>
      <span>Transfert</span>
    </a>
    <a routerLink="/utilisateurs/transferts" routerLinkActive="active">
      <i class="bi bi-clock-history"></i>
      <span>Activité</span>
    </a>
    <a routerLink="/informations/personel" routerLinkActive="active">
      <i class="bi bi-person-circle"></i>
      <span>Profil</span>
    </a>
  </nav>

  <div *ngIf="clientOperationRequest" class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered modal-md client-op-modal" role="document">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title mb-0">
            Validation client requise
          </h5>
          <span class="badge bg-light text-dark">#{{clientOperationRequest.confirmationId}}</span>
        </div>
        <div class="modal-body">
          <p class="mb-2 text-muted">Un caissier demande votre autorisation avant exécution ledger.</p>

          <div class="card border-0 bg-light mb-3">
            <div class="card-body py-3">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Opération</span>
                <strong>{{getClientOperationTypeLabel(clientOperationRequest.operationType)}}</strong>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">
                  {{ isWithdrawalOperation(clientOperationRequest) ? 'Montant retrait' : 'Montant' }}
                </span>
                <strong class="text-primary">
                  {{ isWithdrawalOperation(clientOperationRequest)
                  ? getWithdrawalAmountLabel(clientOperationRequest)
                  : getClientOperationAmountLabel(clientOperationRequest) }}
                </strong>
              </div>
              <div class="d-flex justify-content-between mb-2" *ngIf="isWithdrawalOperation(clientOperationRequest)">
                <span class="text-muted">Taxe Etat</span>
                <strong class="text-dark">{{getWithdrawalTaxLabel(clientOperationRequest)}}</strong>
              </div>
              <div class="d-flex justify-content-between mb-2" *ngIf="isWithdrawalOperation(clientOperationRequest)">
                <span class="text-muted">Frais</span>
                <strong class="text-dark">{{getWithdrawalFeeLabel(clientOperationRequest)}}</strong>
              </div>
              <div class="d-flex justify-content-between mb-2" *ngIf="isWithdrawalOperation(clientOperationRequest)">
                <span class="text-muted font-weight-bold">Total débité</span>
                <strong class="text-danger">{{getWithdrawalTotalDebitLabel(clientOperationRequest)}}</strong>
              </div>
              <div class="d-flex justify-content-between mb-2" *ngIf="clientOperationRequest.businessName">
                <span class="text-muted">Marchand</span>
                <strong>{{clientOperationRequest.businessName}}</strong>
              </div>
              <div class="d-flex justify-content-between mb-2" *ngIf="clientOperationRequest.caissierUsername">
                <span class="text-muted">Caissier</span>
                <strong>{{clientOperationRequest.caissierUsername}}</strong>
              </div>
              <div class="d-flex justify-content-between mb-0" *ngIf="clientOperationRequest.primaryAccountNumber">
                <span class="text-muted">Compte</span>
                <strong>{{clientOperationRequest.primaryAccountNumber}}</strong>
              </div>
            </div>
          </div>

          <div class="alert alert-warning py-2 mb-2" *ngIf="isClientOperationExpired(clientOperationRequest)">
            Cette demande a expiré. Vous pouvez la fermer.
          </div>

          <small class="text-muted d-block mb-2">
            Expire le: {{getClientOperationExpiryLabel(clientOperationRequest.expiresAt)}}
          </small>

          <div class="text-danger small" *ngIf="clientOperationDecisionError">
            {{clientOperationDecisionError}}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" [disabled]="clientOperationDecisionLoading"
            (click)="decideClientOperation(false)">
            Refuser
          </button>
          <button type="button" class="btn btn-success"
            [disabled]="clientOperationDecisionLoading || isClientOperationExpired(clientOperationRequest)"
            (click)="decideClientOperation(true)">
            <span *ngIf="!clientOperationDecisionLoading">Confirmer</span>
            <span *ngIf="clientOperationDecisionLoading" class="spinner-border spinner-border-sm me-2"></span>
            <span *ngIf="clientOperationDecisionLoading">Traitement...</span>
          </button>
          <button type="button" class="btn btn-link"
            *ngIf="isClientOperationExpired(clientOperationRequest) && !clientOperationDecisionLoading"
            (click)="dismissClientOperationModal()">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="clientOperationRequest" class="modal-backdrop fade show"></div>
</div>
